export const config = {
    firebase: {
        apiKey: "AIzaSyCQ7gwug96WK2tQnUv8Ov-vcGfcU7byHyg",
        authDomain: "nda-pwa.firebaseapp.com",
        databaseURL: "https://nda-pwa.firebaseio.com",
        projectId: "nda-pwa",
        storageBucket: "nda-pwa.appspot.com",
        messagingSenderId: "809523872156"
    },
    localstorage: {
        userKey: 'uid'
    }
}




// WEBPACK FOOTER //
// ./src/config.js